import { useI18n } from '@hydra/common/customHooks';
import { useCallback, useEffect, useState } from 'react';
import * as fetcher from '@hydra/utils/fetcher';

export default function usePricingPageFaqs () {
  const { locale } = useI18n();
  const [articles, setArticles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const loadArticles = useCallback(async () => {
    setIsLoading(true);
    try {
      const data = await fetcher.get('/api/pricing/faqs', {
        searchParams: {
          language: locale
        }
      }).json();
      setArticles(data);
    } catch (error) { } finally {
      setIsLoading(false);
    }
  }, [locale]);

  useEffect(() => {
    loadArticles();
  }, [loadArticles]);

  return { articles, isLoading };
}
